import React from "react";

const Navbar = ({onPageChange, currentPage, pageConstant}) => {
  return (
    <div className="tabs-header-container">
      <div className="wrap-item">
      <div className={`tab-customer tabs-header-item ${currentPage === pageConstant.CUSTOMER ? "active" : ""}`} onClick={() => onPageChange("customer")}>
          <div className="tab-item-title">
            <div
              className="svg-next-icon mr10"
              style={{
                backgroundColor: "rgb(108, 121, 143)",
                maskImage:
                  'url("https://static.harasocial.com/svg-funnel/icon_profile.svg")',
                maskRepeat: "no-repeat",
                maskSize: "16px",
                width: "16px",
                height: "16px",
              }}
            ></div>
            <span>Khách hàng</span>
          </div>
        </div>

        {/* <div className={`tabs-header-item ${currentPage === pageConstant.CUSTOMERGROUP ? "active" : ""}`} onClick={() => onPageChange("customerGroup")}>
          <div className="tab-item-title">
            <div
              className="svg-next-icon mr10"
              style={{
                backgroundColor: "rgb(155, 165, 180)",
                maskImage:
                  'url("https://static.harasocial.com/svg-funnel/segment.svg?v=1")',
                maskRepeat: "no-repeat",
                maskSize: "16px",
                width: "16px",
                height: "16px",
              }}
            ></div>
            <span>Nhóm khách hàng</span>
          </div>
        </div> */}
      </div>
    </div>
  );
};
export default Navbar;
